module.exports = __webpack_public_path__ + "static/media/03 Generali OZE Ustandaryzowany dokument.ea50d4ad.pdf";